import { useTranslation } from "react-i18next";
import { formatTodayDate, greetingSlot } from "./greeting";

/**
 * The Today eyebrow + headline, shared by the desktop and mobile headers so
 * both surfaces greet the same way and format the date with the same rules.
 */
export function useTodayGreeting(name: string, now: Date = new Date()) {
  const { t, i18n } = useTranslation("dashboard");
  const greeting = t(`hero.greeting.${greetingSlot(now.getHours())}`);
  const heading = name
    ? t("hero.greetingWithName", { greeting, name })
    : greeting;
  return { dateLabel: formatTodayDate(now, i18n.language), heading };
}
